
import { computed, defineComponent, watch } from 'vue';
import { useStore } from '@/store';
import DateOfCalendar from '@/class/DateOfCalendar';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  name: 'CalendarBodyDate',
  props: {
    dateOfCalendar: {
      type: DateOfCalendar,
      default: new DateOfCalendar(),
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const isChosedDate = computed(() => !props.dateOfCalendar.isDisable && route.params.dateString === props.dateOfCalendar.dateString);

    const watchDataLoaded = () => {
      watch(
        () => props.dateOfCalendar,
        () => {
          if (isChosedDate.value) {
            store.commit('setCurrentDate', props.dateOfCalendar);
          }
        },
        { deep: true },
      );
    };
    watchDataLoaded();

    const chooseDate = () => {
      if (!props.dateOfCalendar.isDisable) {
        if (isChosedDate.value) {
          router.push({ name: 'DateDetail', params: { dateString: store.state.currentDate.dateString } });
        } else {
          store.commit('setCurrentDate', props.dateOfCalendar);
          router.push({ name: 'Calendar', params: { dateString: store.state.currentDate.dateString } });
        }
      }
    };

    const postsToDisplay = computed(() => {
      const { posts } = props.dateOfCalendar;
      if (!posts) return [];
      if (posts.length > 3) {
        return posts.slice(0, 2);
      }
      return posts;
    });

    const hasPosts = computed(() => postsToDisplay.value.length > 0);

    return {
      chooseDate,
      isChosedDate,
      postsToDisplay,
      hasPosts,
    };
  },
});
